import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaiairporttonashikcab() {



    const cardData = {

keyword: "Navi Mumbai Airport to Nashik Cab",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Navi Mumbai Airport to Nashik Cab services for one-way trips, round trips, corporate travel, family tours, pilgrimage journeys, and outstation travel. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, flight tracking support, transparent pricing, and doorstep pickup from Navi Mumbai Airport, we ensure a smooth, comfortable, and hassle-free journey to Nashik and nearby destinations.",

topPlaces: [
    {
        title: "Trimbakeshwar Jyotirlinga",
        description:
            "Trimbakeshwar is one of the twelve sacred Jyotirlingas of Lord Shiva and the most visited pilgrimage destination near Nashik, attracting devotees throughout the year."
    },
    {
        title: "Sula Vineyards",
        description:
            "Sula Vineyards is India's most famous wine tourism destination, offering vineyard tours, wine tasting experiences, and scenic countryside views."
    },
    {
        title: "Panchvati",
        description:
            "Panchvati is a sacred area associated with the Ramayana, featuring famous temples, ghats, and religious landmarks in Nashik."
    },
    {
        title: "Anjaneri Hills",
        description:
            "Anjaneri Hills are believed to be the birthplace of Lord Hanuman and are popular for trekking, spirituality, and panoramic mountain views."
    },
    {
        title: "Godavari River Ghats",
        description:
            "The Godavari Ghats in Nashik are important pilgrimage sites where devotees gather for rituals, prayers, and holy bathing ceremonies."
    },
    {
        title: "Muktidham Temple",
        description:
            "Muktidham Temple is a well-known marble temple complex featuring replicas of major Hindu pilgrimage sites and religious scriptures."
    },
    {
        title: "Harihar Fort",
        description:
            "Harihar Fort is a famous trekking destination near Nashik known for its steep rock-cut steps and breathtaking views of the Sahyadri ranges."
    },
    {
        title: "Pandavleni Caves",
        description:
            "Pandavleni Caves are ancient Buddhist rock-cut caves showcasing historical carvings, inscriptions, and panoramic views of Nashik city."
    },
    {
        title: "Igatpuri Hill Station",
        description:
            "Igatpuri is a scenic hill station on the Nashik route known for waterfalls, mountains, monsoon beauty, and the famous Vipassana Meditation Centre."
    },
    {
        title: "Bhandardara",
        description:
            "Bhandardara is a picturesque lakeside destination known for Arthur Lake, Randha Falls, Wilson Dam, and peaceful natural surroundings."
    }
],



services: [
{
name: "Navi Mumbai to Nashik Cab",
description: "Mumbai Airport Cab offers Navi Mumbai to Nashik Cab service for safe, reliable, and comfortable intercity travel between Navi Mumbai and Nashik. Whether you are travelling for pilgrimage visits, business trips, family travel, weekend getaways, or industrial visits, we provide well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Ertiga, Kia Carens, and Tempo Traveller. Our professional chauffeurs ensure smooth highway driving via Mumbai-Nashik Expressway, timely pickup, luggage assistance, and stress-free journey experience. With 24x7 availability, doorstep service, transparent pricing, and flexible booking options, we make your Nashik travel easy and comfortable."
},
{
name: "Navi Mumbai Airport to Nashik Cab",
description: "Navi Mumbai Airport to Nashik Cab service by Mumbai Airport Cab provides dependable airport-to-city transportation with clean, air-conditioned vehicles and experienced chauffeurs. Ideal for pilgrims, families, and corporate travellers, we ensure safe highway travel, punctual pickup, and comfortable seating for a smooth journey from airport to Nashik."
},
{
name: "Navi Mumbai Airport to Nashik Taxi",
description: "Navi Mumbai Airport to Nashik Taxi service offers reliable and affordable airport transfers with professional drivers and well-maintained vehicles. Mumbai Airport Cab ensures timely pickup, safe driving, and comfortable travel for all passengers."
},
{
name: "Navi Mumbai Airport to Nashik Cab Service",
description: "Navi Mumbai Airport to Nashik Cab Service provides smooth and efficient transportation for passengers travelling between airport and Nashik city. Mumbai Airport Cab ensures punctual service, clean vehicles, and comfortable journeys."
},
{
name: "Taxi from Navi Mumbai Airport to Nashik",
description: "Taxi from Navi Mumbai Airport to Nashik service ensures convenient pickup from airport and direct drop to Nashik with safe highway travel and luggage assistance."
},
{
name: "Cab from Navi Mumbai Airport to Nashik",
description: "Cab from Navi Mumbai Airport to Nashik service offers direct intercity travel with experienced chauffeurs and comfortable vehicles for a stress-free journey."
},
{
name: "Navi Mumbai to Nashik Cab Fare",
description: "Navi Mumbai to Nashik Cab Fare with Mumbai Airport Cab is transparent, affordable, and based on vehicle type and distance. We offer clear pricing with no hidden charges and flexible options for one-way and round-trip travel."
},
{
name: "Book Cab Navi Mumbai Airport to Nashik",
description: "Book Cab Navi Mumbai Airport to Nashik service allows quick and easy online booking with instant confirmation. Mumbai Airport Cab provides 24x7 support and multiple vehicle options."
},
{
name: "Online Cab Booking Navi Mumbai Airport to Nashik",
description: "Online Cab Booking Navi Mumbai Airport to Nashik enables fast digital reservations for intercity travel. Mumbai Airport Cab ensures easy booking, transparent pricing, and reliable service."
},
{
name: "Best Cab Navi Mumbai Airport to Nashik",
description: "Best Cab Navi Mumbai Airport to Nashik service provides premium and reliable transportation with experienced chauffeurs and comfortable vehicles for a smooth journey."
},
{
name: "Cheapest Cab Navi Mumbai Airport to Nashik",
description: "Cheapest Cab Navi Mumbai Airport to Nashik service offers budget-friendly travel without compromising safety or comfort. Mumbai Airport Cab ensures economical pricing and reliable service."
},
{
name: "Reliable Taxi Navi Mumbai Airport to Nashik",
description: "Reliable Taxi Navi Mumbai Airport to Nashik service ensures safe, punctual, and consistent airport-to-Nashik transfers with professional chauffeurs."
},
{
name: "One Way Cab Navi Mumbai Airport to Nashik",
description: "One Way Cab Navi Mumbai Airport to Nashik service offers affordable single-trip travel without return charges. Mumbai Airport Cab ensures transparent pricing and comfortable rides."
},
{
name: "Round Trip Cab Navi Mumbai Airport to Nashik",
description: "Round Trip Cab Navi Mumbai Airport to Nashik service provides complete return journey solutions for family, business, and pilgrimage travel with flexible scheduling."
},
{
name: "Airport Pickup Cab Navi Mumbai to Nashik",
description: "Airport Pickup Cab Navi Mumbai to Nashik service provides timely pickup from airport and smooth highway transfer to Nashik with luggage assistance and professional chauffeurs."
},
{
name: "Innova Crysta Cab Navi Mumbai Airport to Nashik",
description: "Innova Crysta Cab Navi Mumbai Airport to Nashik service offers premium spacious travel for families and groups with maximum comfort, safety, and luggage space."
},
{
name: "Innova Cab Navi Mumbai Airport to Nashik",
description: "Innova Cab Navi Mumbai Airport to Nashik service provides comfortable and reliable SUV travel for long-distance airport transfers and family trips."
},
{
name: "Ertiga Cab Navi Mumbai Airport to Nashik",
description: "Ertiga Cab Navi Mumbai Airport to Nashik service offers budget-friendly 6-7 seater travel for families and small groups with safe and smooth journey experience."
},
{
name: "Swift Dzire Cab Navi Mumbai Airport to Nashik",
description: "Swift Dzire Cab Navi Mumbai Airport to Nashik service provides economical and comfortable sedan travel for solo and small group airport transfers."
}
],

tableData: [
["Navi Mumbai to Nashik Cab","Navi Mumbai Airport to Nashik Cab"],
["Navi Mumbai Airport to Nashik Taxi","Navi Mumbai Airport to Nashik Cab Service"],
["Taxi from Navi Mumbai Airport to Nashik","Cab from Navi Mumbai Airport to Nashik"],
["Navi Mumbai to Nashik Cab Fare","Book Cab Navi Mumbai Airport to Nashik"],
["Online Cab Booking Navi Mumbai Airport to Nashik","Best Cab Navi Mumbai Airport to Nashik"],
["Cheapest Cab Navi Mumbai Airport to Nashik","Reliable Taxi Navi Mumbai Airport to Nashik"],
["One Way Cab Navi Mumbai Airport to Nashik","Round Trip Cab Navi Mumbai Airport to Nashik"],
["Airport Pickup Cab Navi Mumbai to Nashik","Innova Crysta Cab Navi Mumbai Airport to Nashik"],
["Innova Cab Navi Mumbai Airport to Nashik","Ertiga Cab Navi Mumbai Airport to Nashik"]
],











whychoose: [
    {
        WhyChooseheading: "Reliable Navi Mumbai Airport to Nashik Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Navi Mumbai Airport to Nashik Cab services for business travelers, pilgrims, tourists, families, and corporate professionals seeking comfortable transportation."
    },
    {
        WhyChooseheading: "Direct Airport to Nashik Travel Solution",
        WhyChoosedescription: "Passengers arriving at Navi Mumbai Airport can enjoy hassle-free direct transportation to Nashik without changing trains, buses, or multiple modes of travel."
    },
    {
        WhyChooseheading: "Perfect for Religious and Business Travel",
        WhyChoosedescription: "Nashik is a major pilgrimage, industrial, educational, and wine tourism destination, making it a preferred choice for both business and leisure travelers."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and luggage requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Facilities",
        WhyChoosedescription: "Whether you require a one-way transfer, return journey, same-day travel, or customized travel package, we provide flexible booking options."
    },
    {
        WhyChooseheading: "Flight Monitoring and Timely Pickup",
        WhyChoosedescription: "Our team tracks flight schedules and adjusts pickup timings accordingly to ensure smooth airport transfers even during delays or schedule changes."
    },
    {
        WhyChooseheading: "Experienced Drivers for Highway Travel",
        WhyChoosedescription: "Our professional chauffeurs are experienced on Mumbai-Nashik routes and ensure safe, comfortable, and punctual transportation throughout the journey."
    },
    {
        WhyChooseheading: "Ideal for Families, Pilgrims, and Corporate Travelers",
        WhyChoosedescription: "From individual travelers and families to corporate teams and pilgrimage groups, we provide suitable vehicles for every airport transfer requirement."
    }
]
};

const faqData = [
    {
        question: "Why do travelers book Navi Mumbai Airport to Nashik Cabs?",
        answer: "Many travelers prefer direct cab transportation for convenience, comfort, time savings, business visits, religious tours, and family travel."
    },
    {
        question: "Can I book a one-way cab from Navi Mumbai Airport to Nashik?",
        answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicle is suitable for Navi Mumbai Airport to Nashik travel?",
        answer: "Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to passenger count and luggage requirements."
    },
    {
        question: "Do you provide airport pickup from all terminals?",
        answer: "Yes, pickup services are available from all operational terminals at Navi Mumbai Airport."
    },
    {
        question: "Can pilgrims use this service for Trimbakeshwar Darshan?",
        answer: "Yes, customers frequently book cabs from Navi Mumbai Airport to Nashik and Trimbakeshwar Jyotirlinga for pilgrimage purposes."
    },
    {
        question: "Are Tempo Travellers available for group airport transfers?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, pilgrimage tours, corporate teams, and tourist groups."
    },
    {
        question: "Will the driver wait if my flight is delayed?",
        answer: "Yes, flight schedules are monitored and pickup timings are adjusted according to actual flight arrivals."
    },
    {
        question: "Can I visit Trimbakeshwar and Nashik sightseeing spots during the trip?",
        answer: "Yes, customers can customize their itinerary and include Trimbakeshwar Temple, Panchavati, Sita Gufa, Ram Kund, vineyards, and other attractions."
    },
    {
        question: "Is advance booking recommended for Navi Mumbai Airport to Nashik travel?",
        answer: "Yes, advance booking is recommended to secure your preferred vehicle and ensure smooth travel arrangements."
    },
    {
        question: "How can I book a Navi Mumbai Airport to Nashik Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Harshal Patil",
        feedback:
            "After landing at Navi Mumbai Airport, we directly traveled to Nashik in a comfortable Innova. The driver was professional and the entire journey was smooth and relaxing.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Vaishali Deshmukh",
        feedback:
            "We booked a cab for Trimbakeshwar Darshan from Navi Mumbai Airport. The vehicle was clean, spacious, and the service was excellent throughout the trip.",
        rating: 5
    }
];



























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Navi Mumbai Airport to Nashik Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/navi-mumbai-airport-to-nashik-cab.jpg",
"description": "Book Navi Mumbai Airport to Nashik cab service for safe and comfortable outstation travel. Mumbai Airport Cabs offers reliable taxi service with professional drivers, flexible one-way and round-trip options, and 24x7 availability for airport transfers and long-distance journeys.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/navi-mumbai-airport-to-nashik-cab"
}
};





    return (
        <div>


<Helmet>
  <title>Navi Mumbai Airport to Nashik Cab | Outstation Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Navi Mumbai Airport to Nashik cab for safe and comfortable outstation travel. Reliable taxi service with professional drivers, one-way and round-trip options, and 24x7 availability."
/>

<meta
 name="keywords"
 content="navi mumbai airport to nashik cab, navi mumbai airport to nashik taxi, navi mumbai to nashik cab fare, taxi from navi mumbai airport to nashik, cab from navi mumbai airport to nashik, book cab navi mumbai airport nashik"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>








            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/33.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Navimumbaiairporttonashikcab;